import React from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import Pagination from '../../../components/common/Pagination';
import Moment from '../../../components/utils/Moment';
import VisitView from './VisitView';
import PatientAlerts from './PatientAlerts';

import { getAlerts } from '../utils/alerts';

export default class VisitNotesTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = { page: 0, pageSize: 25 };

    this.state = {
      page: 0,
      pageSize: 25,
      showNotes: false,
      editFlagsMode: false,
    };
  }

  componentWillMount() {
    if (this.props.page > 0) {
      this.setState({ page: this.props.page });
    }
    if (this.props.perPage > 0) {
      this.setState({ pageSize: this.props.perPage });
    }
  }

  fetchData = (state, instance) => {
    return setTimeout(
      () =>
        this.props.fetchData(this.state.page, state.pageSize).then(res => {
          if (this.refs.notesList) {
            this.setState({
              pageSize: state.pageSize,
            });
          }
        }),
      0,
    );
  };

  getTdProps = (state, rowInfo, column, instance) => {
    return {
      onClick: (e, handleOriginal) => {
        if (!rowInfo) {
          return;
        }
        if (
          this.props.selected &&
          rowInfo.original.visitNoteID === this.props.selected.visitNoteID
        ) {
          this.props.selectNote(null);
        } else if (rowInfo) {
          this.props.selectNote(rowInfo.original);
        }
        if (handleOriginal) {
          handleOriginal();
        }
      },
      style: {
        background:
          rowInfo &&
          this.props.selected &&
          rowInfo.original.visitNoteID === this.props.selected.visitNoteID
            ? 'rgba(0,0,0,.13)'
            : '',
      },
    };
  };

  render() {
    const { search, view } = this.props;
    return (
      <ReactTable
        manual
        ref="notesList"
        defaultPageSize={this.state.pageSize}
        search={search}
        page={this.state.page}
        onPageChange={pageIndex => this.setState({ page: pageIndex })}
        pages={
          this.props.data
            ? Math.ceil(this.props.data.total / this.state.pageSize)
            : 0
        }
        minRows={5}
        loading={this.props.isLoading}
        onFetchData={this.fetchData}
        data={
          this.props.data && this.props.data.list ? this.props.data.list : []
        }
        onSearchChange={this.props.onSearchChange}
        columns={[
          {
            Header: 'Visit Note ID',
            accessor: 'visitNoteID',
          },
          {
            Header: 'Date',
            id: 'dateOfService',
            accessor: d =>
              d.dateOfService && (
                <Moment date={d.dateOfService} format="MM/DD/YYYY" />
              ),
          },
          {
            Header: 'Patient ID',
            accessor: 'patientID',
          },
          {
            Header: 'Actions',
            id: 'actions',
            Cell: d => {
              const info = d.original;
              return (
                <span>
                  {info.isFollowUp && (
                    <span className="label label-info">F/U</span>
                  )}
                  {info.isReviewed && (
                    <span className="label label-default">Reviewed</span>
                  )}
                  {info.isResolved && (
                    <span className="label label-success">Resolved</span>
                  )}
                </span>
              );
            },
          },
          {
            Header: 'Visit Type',
            accessor: 'visitReason',
          },
          {
            Header: 'Age',
            accessor: 'age',
            width: 40,
          },
          {
            Header: 'Gender',
            accessor: 'sex',
            width: 40,
          },
          {
            Header: 'Reason for Visit',
            accessor: 'reason',
          },
          {
            Header: 'Flags',
            id: 'flags',
            Cell: d => {
              const info = d.original;
              return (
                <span>
                  {info.mskFlag === 'Y' && info.mskFlag2 === 'yes' && (
                    <span className="label label-danger">MSK</span>
                  )}
                  {info.mskFlag === 'Y' && info.mskFlag2 === 'maybe' && (
                    <span className="label label-warning">MSK</span>
                  )}
                  {info.mskFlag === 'Y' && (info.mskFlag2 === 'no' || info.mskFlag2 === 'N/A') && (
                    <span className="label" style={{ backgroundColor: '#000' }}>MSK</span>
                  )}
                  {info.mskFlag === 'N' && !!info.mskFlag2 && info.mskFlag2 !== 'N/A' && info.mskFlag2 !== 'no' && (
                    <span className="label label-default">MSK</span>
                  )}
                  {info.diabetesFlag === '1' && (
                    <span className="label label-danger">Diabetes</span>
                  )}
                </span>
              );
            },
          },
          {
            Header: 'Alerts',
            Cell: d => {
              const alerts = getAlerts(d.original, this.props.limits);
              return (
                <div className="alerts">
                  <PatientAlerts alerts={alerts} />
                </div>
              );
            },
          },
          {
            Header: 'Signed By',
            accessor: 'signedBy',
          },
        ]}
        freezeWhenExpanded={true}
        SubComponent={row => (
          <VisitView
            view={view}
            data={row.original}
            actions={this.props.actions}
            encounters={this.props.encounters}
            bullets={this.props.bullets}
            lookups={this.props.lookups}
            medications={this.props.medications}
            limits={this.props.limits}
            isEncountersLoading={this.props.isEncountersLoading}
            isActionsLoading={this.props.isActionsLoading}
            isBulletsLoading={this.props.isBulletsLoading}
            isActionSubmitting={this.props.isActionSubmitting}
            isMedicationsLoading={this.props.isMedicationsLoading}
            history={this.props.history}
            isHistoryLoading={this.props.isHistoryLoading}
            showNotes={this.props.showNotes}
            toggleNotes={this.props.toggleNotes}
            editFlagsMode={this.state.editFlagsMode}
            addAction={this.props.addAction}
          />
        )}
        getTdProps={this.getTdProps}
        className="-striped -highlight visit-notes-list-table"
        showPaginationTop={true}
        PaginationComponent={Pagination}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/management/components/VisitNotesTable.js